import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-warning-dialog',
  templateUrl: './warning-dialog.component.html',
  styleUrl: './warning-dialog.component.scss',
  standalone: false
})
export class WarningDialogComponent {
  data = inject<{
    message: string;
    closeButtonLabel?: string;
  }>(MAT_DIALOG_DATA);

  get closeButtonLabel(): string {
    return this.data.closeButtonLabel ?? 'Close';
  }
}
